import { render, staticRenderFns } from "./AccountFranchisorMembership.vue?vue&type=template&id=00f963c4&scoped=true&"
import script from "./AccountFranchisorMembership.vue?vue&type=script&lang=js&"
export * from "./AccountFranchisorMembership.vue?vue&type=script&lang=js&"
import style0 from "./AccountFranchisorMembership.vue?vue&type=style&index=0&id=00f963c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f963c4",
  null
  
)

export default component.exports